<template>
  <div class="vheader">
    <div class="ncuthead_01" style="padding: 0.25rem; text-align: left;"
      v-bind:style="{'background': headerColor, 'background-image': headerImg}">
      <el-row type="flex" justify="space-around" :gutter="30">
      <el-col :span="6">
        <a href="#">
          <img src="@/assets/images/title1.png" class="logo" alt="NCUT勤益校徵圖示" title="NCUT Logo" />
        </a>
      </el-col>
      <!-- <span class="locale-changer" style="position: absolute; top: 0.5rem; right: 13.5em;"
        v-show="false">
        <el-radio-group v-model="$i18n.locale" size="mini" style="vertical-align: top;">
          <el-radio-button 
            v-for="(lang, i) in langs"
            :key="`Lang${i}`"
            :label="lang[0]" >{{lang[1]}}
          </el-radio-button>
        </el-radio-group>
      </span> -->
      <el-col :span="18">
        <div class="head_linker">
          <a class="head_a" href="#"  @click.prevent="contactUs()">&nbsp;{{$t('message.Contacts_txt')}}&nbsp;</a> <span v-if="user.isInit">| <a class="head_a" href="#" @click.prevent="logout()" >&nbsp;{{$t('message.Sign_out')}}&nbsp;</a></span>| <a class="head_a" href="https://www.ncut.edu.tw/" target="_blank">&nbsp;{{$t('message.NCUT_txt')}}&nbsp;</a>
        </div>
        <div class="cy-partition-line-solid mt-1 cy-bc"
          v-if="enroll!=null"
          style="">
          <span class="sys-title-font hidden-xs-only">{{enroll.actTitle}}</span>
          <span class="sys-title-font-sm hidden-sm-and-up">{{enroll.actTitle}}</span>
        </div>
      </el-col>
    </el-row>
    </div>
   
  </div>
</template>

<script>
export default {
  name: 'vheader',
  props: [
    'pageInfo'
  ],
  data () {
    return {
      activeIndex: '1',
      langs: [
        ['tw', '繁'],
        ['cn', '簡'],
        ['en', 'En']
      ]
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    setting () {
      return this.$store.getters.getSetting
    },
    enroll () {
      return this.$store.getters.getEnrollInfo
    },
    headerImg () {
      let url = '';
      if (this.setting!=null && this.setting.headerFile != null && this.setting.headerFile[0]!= null && this.setting.headerFile[0].codeName.length>0) {
         url  = 'url(./WebApi/Tools/ShowSystemDocByType/'.concat(this.$store.getters.getSysId).concat('/').concat(2).concat(')');
      }
      return url
    },
    headerColor () {
      let url = '';
      //if (this.setting!=null && (this.setting.headerFile == null || this.setting.headerFile[0]== null || this.setting.headerFile[0].codeName.length==0)) {
      if (this.setting!=null && this.setting.bgColor != null && this.setting.bgColor[0]!= null && this.setting.bgColor[0].codeName.length>0) {
        //url  = 'linear-gradient(0deg, #c6e6e8 0%, #33E6CC 100%)';
        url = this.setting.bgColor[0].codeName;
      }
      return url
    },
    showTitle() {
      var ret = false;
      if (this.setting!=null) {
        ret = (this.setting.showTitle[0].codeName=='1');
      }
      return ret;
    }
  },
  filters: {
    dateFormat: function (input) {
      var d = new Date(input)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      var hh = d.getHours()
      var ss = d.getMinutes()
      return year + '年' + month + '月' + day + '日' + hh + '時' + ss + '分'
    }
  },
  methods: {
    contactUs: function() {
      this.$emit('toggle', -2, -2)
    },
    loginIn: function() {
      this.$emit('toggle', -3, -3)
    },
    toggle: function (appId, pageId) {
      console.log('toggle call' + appId, pageId)
      this.$emit('toggle', appId, pageId)
    },
    handleSelect: function (key, keyPath) {
      console.log(key, keyPath)
    },
    logout: function () {
      var user = {
        id1: this.$store.state.user.id,
        id2: '',
        id3: '',
        isLogin: false
      }
      var vm = this
      this.$http.put('./WebApi/Common/Authorized', user)
        .then((response) => {
          if (response.data != null) {
            console.log('logout' + user.id)
            vm.$store.dispatch('resetLogin')
            this.$emit('getDefaultMenu', vm.sysId, false)
          }
        })
        .catch(function (error) {
          this.$message.error('對不起,網路連線失敗' + error)
        })
    }
  },
  created () {
    console.log('======created=====Header')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  display: contents;
}
.head_info {  
  position: absolute;
  bottom: 1em;
  right: 1em;
  color: #ffffa7;
}
.head_a {
  color: white;
  text-decoration: none;
  font-size: 12px;
  font-family: verdana, 'trebuchet ms', sans-serif;
}
.head_linker {
  background-color: rgba(33,99,33, 0.2);
  position: absolute;
  /* top: 0.625rem; */
  right: 1em;
}
.ncuthead_01 {
  position: relative;
  height: 150px;
  /* background: #fafafa url(Content/Images/greengrass0505.jpg) no-repeat; */
  background-position: 0px 0px;
}

.titlementbox {
  position: inherit;
  top: 0.85em;
  left: 10em;
  width: 50em;
  height: 2em;
}
.menu_bar {
  background-color: #00bfff;
  line-height: 3em;
}
.div-container {
  display: table;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
.sys-title-font {
  /* text-align: left; */
  /* margin: 0.75rem 0 0; */
  padding-left: 1.0rem;
  font-size: 2.8rem;
  line-height: 150px;
  font-weight: bolder;
  color: #161823;
  font-family: '標楷體',-apple-system,system-ui,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif;
}

.sys-title-font-sm {
  padding-left: 1.2rem;
  font-size: 1.28rem;
  line-height: 150px;
  font-weight: bolder;
  color: #161823;
  font-family: '標楷體',-apple-system,system-ui,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif;
}

.logo{
  height: 150px; 
  object-fit: scale-down;
  margin-left: 10px;;
}

</style>



// WEBPACK FOOTER //
// src/components/common/HeaderView.vue